import { LogOut } from "lucide-react";

export const AwayBox = ({ away }) => {
  if (!away?.length) return null;
  return (
    <div className="rounded-2xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900" data-testid="away-box">
      <p className="mb-1 flex items-center gap-2 font-semibold"><LogOut className="h-4 w-4" /> Impegnati fuori in questo turno</p>
      {away.map((a, i) => (
        <p key={i} data-testid={`away-item-${i}`}><b>{a.name}</b> · {a.start}-{a.end} · {a.label}</p>
      ))}
    </div>
  );
};
